export const url = 'https://www.nowyousee.cn/'



//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = null
// module chunks = 